// extracted by mini-css-extract-plugin
module.exports = {"permissionsBanner":"share-page_permissionsBanner_1KL"};